import { useEffect } from "react";
import SEO from "@/data/seo-pages.json";
import { CONDITIONS } from "@/data/conditions";
import { SERVICE_GROUPS } from "@/data/services";
import { BACKEND_URL } from "./api";
import * as S from "./schema";

export const SITE_URL = S.SITE_URL;
export const PAGES = SEO.pages;
export const pageSeo = (path) => ({ title: PAGES[path].title, description: PAGES[path].description, path });

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo({ title, description, path = "/", image = "/images/og-image.jpg", jsonLd, noindex = false }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    document.title = title;
    const url = SITE_URL + path;
    const img = image.startsWith("http") ? image : SITE_URL + image;
    setMeta("name", "description", description || "");
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description || "");
    setMeta("name", "twitter:image", img);
    setCanonical(url);
    let s = document.getElementById("page-jsonld");
    if (ld) {
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = "page-jsonld";
        document.head.appendChild(s);
      }
      s.textContent = ld;
    } else if (s) s.remove();
  }, [title, description, path, image, ld, noindex]);
}

export const absImage = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND_URL}${u}` : `${SITE_URL}${u}`);

const CONDITION_TITLES = CONDITIONS.map((c) => c.title);
const SERVICE_NAMES = SERVICE_GROUPS.flatMap((g) => g.items.map(([name]) => name));

export const clinicSchema = (s) => S.clinicSchema(s, { conditions: CONDITION_TITLES, services: SERVICE_NAMES });
export const physicianSchema = (s, c) => S.physicianSchema(s, c, absImage(c.doctor_portrait?.url));
export const crumbs = (...items) => S.breadcrumbSchema([["Home", "/"], ...items]);
export const quickAnswers = (s, c) => S.quickAnswers(SEO.quick_answers, s, c, CONDITION_TITLES);
export const { graph, websiteSchema, faqSchema, medicalPageSchema, productSchema } = S;
